<template>
    <FciDialog :title="this.$f.tc('built-inFunction')" v-model="show" :width="1140">
        <div class="BuiltInFunction">
        <div class="modal-content">
            <div class="row">
            <div class="col-xl-4 col-lg-6 col-md-6 col-xs-12" style="position: relative;">
            <v-text-field
                outlined
                dense
                hide-details
                :label="this.$f.tc('functionName')"
                class="mb-3"
                v-model="searchLuaOptions.name"
                clearable
                @keyup.enter="getListBuiltInLuaFunction"
                prepend-icon="mdi-magnify"
            ></v-text-field>
            </div>
            </div>
            <div class="list-wrapper">
            <ul class="function-list">
                <div v-for="(func) in lst_lua_function_builtin" :key="func.id" style="border-bottom: 1px solid #ccc;">
                    <div  class="icon-desc-container">
                        <FunctionItem  :func ='func' style="width: 100%;" @functionSelected="handleFunctionSelected"></FunctionItem>
                        <v-icon class="ml-6 mr-4" @click="copyFunction(func.name)"
                        style="margin-bottom: 16px; align: right;">mdi-content-copy</v-icon>
                    </div>
                    <v-slide-y-transition>
                    <div v-if="func.show_detail">
                        <FunctionItemDetail :func="func"></FunctionItemDetail>
                    </div>
                    </v-slide-y-transition>
                </div>
            </ul>
            </div>
        </div>
        </div>
    </FciDialog>
</template>

<script>
import { mapState } from 'vuex'
import FciDialog from '@/components/FciDialog'
import DialogPromiseMixin from '@/modules/fptai/mixins/DialogPromiseMixin'
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import FunctionItem from '@/views/Scenario/StepEditor/CustomDialog/LuaFunction/FunctionItem'
import { BotService } from '@/services/bot.service'
import AppService from '@/services/app.service'
import FunctionItemDetail from '@/views/Scenario/StepEditor/CustomDialog/LuaFunction/FunctionItemDetail'

export default {
    name: 'BuiltInFunction',
    components: { FciDialog, FunctionItem, FunctionItemDetail },
    mixins: [DialogPromiseMixin, FormMixin],
    data () {
        return {
            // Lua function built-in
            filter_function_name: '',
            lst_lua_function_builtin: [],
            searchLuaOptions: {
                name: '',
                page: -1,
                pageSize: 10
            },
            lua_page_count: 1
        }
    },
    computed: {
        ...mapState({
            stepList: state => state.scenario.stepList,
            variableList: state => state.scenario.variableList,
            webViewList: state => state.scenario.webViewList
        })
    },
    mounted () {
        this.getListBuiltInLuaFunction()
    },
    methods: {
        async  getListBuiltInLuaFunction () {
            this.lst_lua_function_builtin = []
            AppService.loading()
            let res = await BotService.getListBuiltInLuaFunction(this.$route.params.botCode, this.searchLuaOptions)
            if (res && res.data && res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    let func = res.data[i]
                    func.show_detail = false
                    func.load_detail = false
                    this.lst_lua_function_builtin.push(func)
                }
            }
            this.lua_page_count = res.pagecount
            this.searchLuaOptions.page = res.page
            AppService.hideLoading()
        },
        copyFunction (name) {
            navigator.clipboard.writeText(name + '(')
            AppService.toastSuccess(this.$f.tc('copied'))
        },
        handleFunctionSelected (id) {
            for (let i = 0; i < this.lst_lua_function_builtin.length; i++) {
                if (this.lst_lua_function_builtin[i].id !== id) {
                    this.lst_lua_function_builtin[i].show_detail = false
                    this.lst_lua_function_builtin[i].load_detail = false
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.BuiltInFunction {
    overflow: auto;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    position: relative;

    .v-form {
        flex: 1 1 400px;
    }

    .hidden-input {
        position: absolute;
        left: 0;
        top: -100px;
    }
    .v-icon {
        float: right;
    }
}

.thumb-icon {
    border: 1px solid #D0D4E2;
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;

    img {
        height: 30px;
        display: block;
    }
}

.modal-content {
    width: 100%; /* Set the width to 100% to make it fit the parent */
  max-width: none; /* Remove the maximum width limitation */
  overflow: hidden; /* Hide any overflow to prevent the scroll bar */
  padding: 10px;
}

[v-cloak] {
    display: none;
}

.modal.right .modal-content {
    height: 100%;
    width: 100%;
    position: fixed;
    bottom: 0;
    right: 0;
    overflow-y: auto;
}

/*Right*/
.modal.right .modal-dialog {
    position: fixed;
    margin: auto;
    position: fixed;
    bottom: 0;
    right: 0;
    width: 900px;
    height: 100%;
    -webkit-transform: translate3d(0%, 0, 0);
    -ms-transform: translate3d(0%, 0, 0);
    -o-transform: translate3d(0%, 0, 0);
    transform: translate3d(0%, 0, 0);
}

.modal.right.fade .modal-dialog {
    right: 0px;
    -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
    -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
    -o-transition: opacity 0.3s linear, right 0.3s ease-out;
    transition: opacity 0.3s linear, right 0.3s ease-out;
}
.function-list {
    /* Add list styles here */
    list-style: none;
    padding-left: 0;
    width: 100%;
    float: left;
}

.search-input {
    margin-bottom: 10px;
    margin-top: 10px;
    border: 1px solid #ccc; /* Add a border to the input */
    border-radius: 4px; /* Optional: Add rounded corners to the border */
}
</style>
